<template>
  <div>
    <PurchasedAccProductList :contact-id="contactId" />
  </div>
</template>

<script>
import PurchasedAccProductList from './PurchasedAccProductList.vue';

export default {
  components: {
    PurchasedAccProductList,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
};
</script>
